import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4103a66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hmd-btn dict-form-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_4 = { class: "text-grey" }
const _hoisted_5 = { class: "text-grey" }

export function render(_ctx, _cache) {
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_skeleton = _resolveComponent("a-skeleton")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.showAddUnit)
            ? (_openBlock(), _createBlock(_component_hmd_empty_link, {
                key: 0,
                onClick: _ctx.showEditModal
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.showAddUnit)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: _ctx.showCreateModal
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = $event => ((_ctx.visible) = $event)),
      "confirm-loading": _ctx.createLoading || _ctx.editLoading,
      keyboard: false,
      centered: true,
      "mask-closable": false,
      zIndex: 1200,
      onOk: _ctx.submit,
      onCancel: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isEdit ? "编辑" : "新建") + "结算单位", 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.detailLoading,
          active: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({ label: "结算单位名称" }, _ctx.validateInfos.name), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formRef.name,
                      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.formRef.name) = $event)),
                      valueModifiers: { trim: true },
                      placeholder: "请输入中文名称",
                      maxlength: 10
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formRef.name.length) + "/10", 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_form_item, _mergeProps({ label: "单位符号" }, _ctx.validateInfos.symbol), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formRef.symbol,
                      "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.formRef.symbol) = $event)),
                      valueModifiers: { trim: true },
                      placeholder: "请输入单位符号",
                      maxlength: 10
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formRef.symbol.length) + "/10", 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk", "onCancel"])
  ]))
}